import { SystemStudyTheme1 } from "./systemStudyTheme1";
import { SystemStudyTheme2 } from "./systemStudyTheme2";
import { SystemStudyTheme3 } from "./systemStudyTheme3";
import { SystemStudyTheme4} from "./systemStudyTheme4";
import { SystemStudyTheme5 } from "./systemStudyTheme5";
import { SystemStudyTheme6 } from "./systemStudyTheme6";
import { SystemStudyTheme7 } from "./systemStudyTheme7";
import { SystemStudyTheme8 } from "./systemStudyTheme8";
import { SystemStudyTheme9 } from "./systemStudyTheme9";
/**
 * 样式ID映射关系
 */
 const systemThemeTypeMap: Record<number, string> = {
    42: '1',
    43: '2',
    44: '3',
    45: '4',
    46: '5',
    47: '6',
    48: '7',
    49: '8',
    50: '9',
};
const systemStudyThemeList = [
    SystemStudyTheme1,
    SystemStudyTheme2,
    SystemStudyTheme3,
    SystemStudyTheme4,
    SystemStudyTheme5,
    SystemStudyTheme6,
    SystemStudyTheme7,
    SystemStudyTheme8,
    SystemStudyTheme9
];

export {
    systemThemeTypeMap,
    systemStudyThemeList
}
